<!--Table header-->
<div class="flex flex-row" style="padding: 15px 0px; align-items: center;">
    <div>
        <a class="store-header-inventory-link"
           [ngClass]="(activeMenuTab === menuTab.ActiveProducts) ? 'store-header-inventory-link__active' : ''"
           (click)="changeActiveMenuTab(menuTab.ActiveProducts)">Active Products</a>
        <a class="store-header-inventory-link"
           [ngClass]="(activeMenuTab === menuTab.InactiveProducts) ? 'store-header-inventory-link__active' : ''"
           (click)="changeActiveMenuTab(menuTab.InactiveProducts)">Inactive Products</a>
    </div>
    <div style="margin-left: auto;">
        <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input pInputText type="text" class="search-input"
                   [(ngModel)]="searchProduct" (input)="handleSearchFilterChange()"
                   placeholder="Search product..." />
        </span>
    </div>
</div>

<!--table-->
<div style="height: calc(100vh - 300px)">
    <p-table #storeProductsGrid
             [columns]="cols"
             [value]="storeProducts"
             [lazy]="true"
             [loading]="loading"
             responsiveLayout="scroll" dataKey="UserId"
             (onLazyLoad)="handleLazyLoad($event)"
             [paginator]="true"
             [(first)]="first"
             [rows]="rowsPerPage"
             [rowsPerPageOptions]="rowsPerPageOptions"
             [totalRecords]="totalRecords"
             [resizableColumns]="true"
             [columnResizeMode]="'expand'"
             [autoLayout]="true"
             [styleClass]="'p-datatable-striped'"
             [scrollable]="true"
             [scrollHeight]="'flex'">
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of cols"
                    [pSortableColumn]="col.field"
                    [pSortableColumnDisabled]="col.disableSort"
                    pResizableColumn
                    [style.width]="col.width">
                    {{col.header}}
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
            <tr [pSelectableRow]="product">
                <td class="ui-resizable-column">
                    <div (click)="openMerchantEditProductSideBar(product.Id)" class="table-col-product-id">{{product.Id}}</div>
                </td>
                <td class="ui-resizable-column">
                    <div class="flex flex-row">
                        <div>
                            <img src="{{product.ImageUrl}}" class="table-col-product-img" />
                        </div>
                        <div class="table-col-product-name">
                            {{product.Name}}
                        </div>
                    </div>
                </td>
                <td class="ui-resizable-column">{{product.UOM}}</td>
                <td class="ui-resizable-column">{{product.Units}}</td>
                <td class="ui-resizable-column">{{product.DefaultAmount}}</td>
                <td class="ui-resizable-column">{{product.SupplierName}}</td>
                <td class="ui-resizable-column">
                    <div class="flex flex-row">
                        <div>
                            <p-inputSwitch [(ngModel)]="product.IsEnable" (onChange)="switchProduct(product)"></p-inputSwitch>
                        </div>
                        <div class="table-col-product-isactive">
                            <span *ngIf="product.IsEnable" class="table-col-product-isactive__active">Active</span>
                            <span *ngIf="!product.IsEnable" class="table-col-product-isactive__notactive">Inactive</span>
                        </div>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft" let-state>
            <div *ngIf="storeProducts.length > 0" class="partner-store-empl-tab-footer">
                Showing {{first + 1}} to {{first + storeProducts.length}} of {{totalRecords}} entries
            </div>
        </ng-template>
    </p-table>
</div>

<merchant-edit-product [_showMerchantEditProductSideBar]="showMerchantEditProductSideBar"
                       [_productId]="productId"
                       [partnerMartLocationsInventoryGridComponent]="this"
                       (changedShowMerchantEditProductSideBarEmit)="changedShowMerchantEditProductSideBarEmit($event)"
                       *ngIf="showMerchantEditProductSideBar"></merchant-edit-product>
